var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 673 673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#191b24;}.cls-3{fill:#52d794;}.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-new-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337,660.5A324,324,0,0,1,107.9,107.4,324,324,0,1,1,566.1,565.6,321.85,321.85,0,0,1,337,660.5Z",
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337,25A311.59,311.59,0,0,1,458.24,623.53,311.59,311.59,0,0,1,215.76,49.47,309.44,309.44,0,0,1,337,25m0-25C151.16,0,.5,150.66.5,336.5S151.16,673,337,673,673.5,522.34,673.5,336.5,522.84,0,337,0Z",
    transform: "translate(-0.5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M252,369.91l-2.06,2a2.73,2.73,0,0,0,0,3.87L281.09,407a2.73,2.73,0,0,0,3.87,0L287,405a2.74,2.74,0,0,0,0-3.86l-31.2-31.19A2.72,2.72,0,0,0,252,369.91Z",
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.2,385.59a2.72,2.72,0,0,0,3.86,0l2.06-2a2.73,2.73,0,0,0,0-3.87l-25.77-25.76a2.72,2.72,0,0,0-3.86,0L250.43,356a2.72,2.72,0,0,0,0,3.86Z",
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 440.38,
    y: 363.68,
    width: 8.37,
    height: 49.58,
    rx: 2.73,
    transform: "translate(-144.98 428.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M452.3,385.59a2.73,2.73,0,0,0,3.87,0l2.06-2a2.75,2.75,0,0,0,0-3.87l-25.77-25.76a2.73,2.73,0,0,0-3.87,0l-2,2.06a2.72,2.72,0,0,0,0,3.86Z",
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M507.25,400.66v-5.93a5.43,5.43,0,0,0-5.44-5.43h-7.7a70.49,70.49,0,0,0-139.77-1.66c-3.84.82-18.67,1.66-18.67,1.66s-14-.73-17.85-1.49A70.49,70.49,0,0,0,178,389.3h-7.7a5.43,5.43,0,0,0-5.43,5.43v5.93a5.44,5.44,0,0,0,5.43,5.44H178a70.49,70.49,0,0,0,139.78,1.55c3.95-.79,17.86-1.55,17.86-1.55s14.75.87,18.68,1.72a70.5,70.5,0,0,0,139.76-1.72h7.7A5.44,5.44,0,0,0,507.25,400.66ZM248,451.4a53.71,53.71,0,1,1,53.7-53.7A53.71,53.71,0,0,1,248,451.4Zm176.1,0a53.71,53.71,0,1,1,53.71-53.7A53.7,53.7,0,0,1,424.12,451.4Z",
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M563.16,369V243.55H519.05a304.4,304.4,0,0,0,5-41.72l-26,18.89c14.18-16.53,0-93.78,0-93.78s-18.88,37.1-137,27.66-134.61,37.78-134.61,37.78c-14.16-14.17,0-37.78,0-37.78-33.06,18.89-16.53,49.59-16.53,49.59h-38l26.23,16.53c-8.55,5.26-14.34,13.57-18.26,22.83h-71V369L83,394.81l25.84,25.84V546.06H175.9V413.29a3.33,3.33,0,1,0-6.65,0V515.12H139.13V412.33L121.6,394.81l17.53-17.53V274.49H172.6a147.49,147.49,0,0,0-.47,23.37h23.63c2.35-24.4,18.89-37,18.89-37,40.14-49.6,210.18-20.65,210.18-20.65l18.89-27.82-7.09,27.82C476.7,250,480.27,297,480.27,297H498c5.12-6,9.24-13.86,12.56-22.5h22.27V377.28l17.54,17.53-17.54,17.52V515.12H496.1v30.94h67.06V420.65L589,394.81Z",
    transform: "translate(-0.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a49eebb44b9188880b236a321f05c8a6.svg";
export { ForwardRef as ReactComponent };